<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="form" [formGroup]="form">
  <label
    class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-4 ui-sm-12 ui-xs-12 field-label text-right-align mr-8"
    [class.required]="isRequired || required"
    [for]="controlName">
    {{ label }}
  </label>
  <div class="ui-g-9 ui-xl-9 ui-lg-9 ui-md-9 ui-sm-12 ui-xs-12" id="file-container">
    <input class="doc-submit-inputs disabled" [id]="controlName" pInputText type="text" [formControlName]="controlName" />
    <p-fileUpload
      *ngIf="!isReadOnly"
      #specialDeviceDocument
      chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
      (onSelect)="onSelectFile($event, documentType, specialDeviceDocument, controlName)"
      mode="basic"></p-fileUpload>
    <button
      *ngIf="documentId"
      (click)="downloadDocument()"
      icon="pi pi-download"
      pButton
      type="button"
      class="btn-download ui-fileupload-choose"
      [label]="'download-button-label' | translate"></button>
    <app-tooltip *ngIf="tooltip" [text]="tooltip"></app-tooltip>
  </div>
</div>
